import { Slide } from "@mui/material";
import cn from "classnames";
import useTranslate from "@/hooks/useTranslate";
import { ISideTabProps } from "./SideTab.props";
import styles from "./SideTab.module.scss";

const SideTab = ({ showTab, setShowTab, width, height, ...props }: ISideTabProps): JSX.Element => {
	const translate = useTranslate(); // hook для перевода текста

	// закрыть вкладку
	const closeTab = (): void => {
		setShowTab(false);
	};

	const onMouseDownToTheTab = (e: React.MouseEvent<HTMLDivElement, MouseEvent>): void => {
		e.stopPropagation();
	};

	return (
		<Slide direction="left" in={showTab} mountOnEnter /* unmountOnExit */>
			<div
				className={cn(styles.modal, {
					[styles.modalOpening]: showTab,
					[styles.modalClosing]: !showTab,
				})}
				onMouseDown={closeTab}
			>
				<div className={styles.tab} style={{ width, height }} onMouseDown={onMouseDownToTheTab}>
					<div className={styles.tabInner} {...props}>
						{props.children}
					</div>
					<div className={styles.tagClose} onClick={closeTab}>
						{translate("button_close")}
					</div>
				</div>
			</div>
		</Slide>
	);
};

export default SideTab;
